import React from 'react';
import { Helmet } from 'react-helmet';
import Description from '../components/Disputes/Description';
import Promo from '../components/Disputes/Promo';
import { disputeCases } from '../data/disputeCases';
import Cases from '../components/Cases';

const Disputes = () => (
  <>
    <Promo />
    <Description />
    <Cases data={disputeCases} />
    <Helmet>
      <meta name="description" content="Жилищные вопросы" />
      <title>Центр Юридической помощи «Согласие»</title>
    </Helmet>
  </>
);

export default Disputes;
